<template>
  <div class="data-table">
    <el-table :data="myTableData"
              :cell-style="cellStyles"
              :header-cell-style="headerStyles"
              style="width: 100%"
              @sort-change="handleSortChange"
              :height="heights"

              :row-class-name="tableRowClassName"
              border size="size"
              @selection-change="selectionChange">



      <!-- 选择 -->
      <el-table-column v-if="type=='selection'" type="selection" label="选择" width="50"/>
      <!-- 自定义复选框 -->
      <slot name="checkbox"></slot>
      <!-- 序号 -->
      <el-table-column v-if="indexShow" type="index" label="序号" width="80"/>
      <el-table-column label="序号"  v-if="!indexShow && type == 'index'" type="index" align="center" width="80"  >
        <template slot-scope="scope">
          {{ Number((pageIndex-1)*myPageSize)  + Number(scope.$index+1) }}
        </template>
      </el-table-column>


      <!-- 单元格 -->
      <el-table-column v-for="(item,index) in fieldData"  :key="index" :label="item.label" :prop="item.field" :width="item.width" :minWidth="item.minWidth" :sortable="item.sortable">
        <template slot-scope="scope">
          <template v-if="item.formatter">
            {{ item.formatter(scope.row, item) }}
          </template>
          <template v-else-if="item.cellClick">
            <el-link :underline="false" type="primary" @click="item.cellClick(scope.row, item)">{{ scope.row[item.field] }}</el-link>
          </template>
          <template v-else>
            {{ scope.row[item.field] }}
          </template>
        </template>
        <template v-if="item.children">
          <el-table-column v-for="(children,index) in item.children" :key="index" :label="children.label" :prop="children.field" :width="item.width" :minWidth="children.minWidth" :sortable="children.sortable">
            <template slot-scope="scope">
              <template v-if="children.formatter">
                {{ item.formatter(scope.row, children) }}
              </template>
              <template v-else-if="children.cellClick">
                <el-link @click="children.cellClick(scope.row, item)">{{ scope.row[children.field] }}</el-link>
              </template>
              <template v-else>
                {{ scope.row[children.field] }}
              </template>

            </template>
          </el-table-column>
        </template>
      </el-table-column>

      <!-- 插槽，额外操作按钮，自己控制 -->
      <slot name="opts"></slot>
    </el-table>

      <!-- 分页组件 -->
    <div class="my-pagination" v-if ="page">
      <span class="demonstration" >共{{myTotal}}条记录</span>
      <el-pagination
        @current-change="pageChange"
        :current-page="pageIndex"
        @size-change="sizeChange"
        :page-size="pageSize"
        :page-sizes="pageSizeList"
        :layout="pageLayout"
        :total="myTotal"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      checkTrData: [], // 多选数据
      myTableData: this.tableData,
      myTotal: this.total, // 总条数
      myPageSize: this.pageSize, // 每页条数

    }
  },
  props: {
    indexShow:'',
    pageIndex:{
      default: 1,
      type: Number,
    },
    heights:'',
    headerStyles:{
      default: "",
      type: Object,
    },
    cellStyles:'',
    // 数据总条数

    total: {
      default: 0,
      type: Number
    },
    // 表格类型：带索引、选择框
    type: {
      default: "",
      type: String
    },
    // 字段集合
    fieldData: {
      default: (() => []),
      type: Array
    },
    // 表格数据集合
    tableData: {
      default: (() => []),
      type: Array
    },
    // 表格大小
    size: {
      default: "medium",
      type: String
    },
    // 是否需要分页
    page: {
      default: false,
      type: Boolean
    },
    // 每页显示条数 需要与引用组件的pageSize保持一致
    pageSize: {
      default: 10,
      type: Number
    },
    // 可切换每页条数集合
    pageSizeList: {
      default: (() => [10,20,50,100]),
      //default: [10,20,50,100],
      type: Array
    },
    pageLayout: {
      default: "prev, pager, next",
      type: String
    },
    handleSelectionChange: {
      type: Function,
      default: () => {
        return () => {}
      }
    },

  },
  mounted() {
  },
  watch: {
    // 监控表格数据修改，重新渲染表格
    tableData() {
      this.myTableData = this.tableData;
    },
    // 监听页面数据总数修改
    total() {
      this.myTotal = this.total;
    },
    // 修改每页条数
    pageSize() {
      this.myPageSize = this.pageSize;
    }
  },
  methods: {
    handleSortChange({ prop, order }) {

      let obj = {
        prop:prop,
        order:order,
      }

      this.$emit("handleSortChange", obj);
      // this.currentSort.prop = prop;
      // this.currentSort.order = order;
      // this.fetchData();
    },


      selectionChange(choosetr) {
      this.checkTrData = choosetr;
      this.$emit('selectionChange', this.checkTrData);
    },
    sizeChange(size) {
      this.$emit("sizeChange", size);
    },
    getChooseData() {
      return this.checkTrData;
    },
    // @row-click="handleRowClick"
    // handleRowClick(row, column, event) {
    //   console.log('行点击事件触发，点击的行数据：', row);
    //   // 在这里处理行点击事件
    // },
    tableRowClassName({row, rowIndex}) {
      if (row.flag == '1' || row.flag == '2') {
        return 'warning-row';
      }
      // console.log(1234567,row.signErr,row.EditStatus)
      if (row.signErr !=1 ){  //&& row.EditStatus !=0

        return 'blueClass';
      }
      return '';

    },


    // 分页
    pageChange(pageIndex) {
      this.$emit("pageChange", pageIndex);

    }
  }
};
</script>

<style lang="less" scoped>
.blueClass{
  color: blue !important;
}
.my-pagination{
  display: flex;
  float: right;


  .el-pagination{
    text-align: right;
  }
  .demonstration{
    color: rgb(27, 61, 109);
    font-size: 0.75rem;
    line-height: 2rem;
  }
}



*{
  ::-webkit-scrollbar{
    //display: inline-block;

  }
}

/* 定制滚动条轨道在被滚动时的颜色 */
::-webkit-scrollbar-track:hover {
  background-color: #ff6700; /* 设置轨道hover状态的颜色 */
}
</style>



// WEBPACK FOOTER //
// src/comm/components/Table/index.vue